var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKycSubheaderIcon = function SvgKycSubheaderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.167h-1.667a1.667 1.667 0 0 0-1.666 1.666v10a1.666 1.666 0 0 0 1.666 1.667h8.334a1.667 1.667 0 0 0 1.666-1.667v-10a1.667 1.667 0 0 0-1.666-1.666H17.5m-5 0a1.667 1.667 0 0 0 1.667 1.666h1.666A1.667 1.667 0 0 0 17.5 9.167m-5 0A1.667 1.667 0 0 1 14.167 7.5h1.666A1.666 1.666 0 0 1 17.5 9.167M15 15h2.5M15 18.333h2.5M12.5 15h.008m-.008 3.333h.008",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgKycSubheaderIcon;